module.exports = "<!-- <div>\r\n\r\n</div> -->\r\n    <iframe #ifrmae class=\"iframe\" id=\"clal\" src=\"\"></iframe>\r\n"